import Link from "next/link";
import { Modal, Button, Card } from "react-bootstrap";
import React, { useContext, useState, useTransition } from "react";
import helper from "../../lib/helper";
import attributesModel from "../../models/attributes.model";
import useSWR from "swr";
import Pagination from "../../components/Pagination";
import Heading from "../../components/Heading";
import Table from "../../components/Table";
import { useRouter } from "next/router";
import config from "../../lib/config";
import { useForm } from 'react-hook-form'
const Page = function () {
    const [showLoader, setShowLoader] = useState(false);
    const [show, setShow] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleCloseEdit = () => setShowEdit(false);
    const handleShowEdit = () => setShowEdit(true);

    const router = useRouter();
    const queryParams = router.query;
    const { data: attributeData, mutate: reloadAttributeData, isLoading } = useSWR(
        queryParams || null,
        () => attributesModel.list(queryParams),
        config.swrConfig
    );

    const {
        register,
        handleSubmit,
        watch,
        setValue,
        formState: { errors },
        setError,
        reset
    } = useForm();

    const onSubmit = handleSubmit(async (data, event) => {
        const formData = new FormData(event.target);

        if (watch('id')) {
            await attributesModel.update(watch('id'), formData).then((response) => {
                helper.sweetalert.toast(response.data?.message);
                reloadAttributeData()
                handleClose(true)
                reset()
            }).catch((error) => {
                helper.sweetalert.toast(error.response.data?.message, 'error');
                _.each(error.response?.data?.errors, function (err, errorKey) {
                    setError(errorKey, { type: "required", message: err });
                });
            });
            return;
        }
        await attributesModel.create(formData).then((response) => {
            helper.sweetalert.toast(response.data?.message);
            reloadAttributeData()
            handleClose(true)
            reset()
        }).catch((error) => {
            helper.sweetalert.toast(error.response.data?.message, 'error');
            _.each(error.response?.data?.errors, function (err, errorKey) {
                setError(errorKey, { type: "required", message: err });
            });
        });
    })



    const columns = [

        {
            Header: "Name",
            accessor: "name",
            className: "col"
        },
        {
            className: "col-auto text-end",
            Header: "Actions",
            id: "action",
            Cell: ({ row }) => (
                <>
                    <div className="btn-group btn-group-sm">
                        <Link
                            className="btn btn-primary"
                            href={`/attributes/${row.original.id}`}
                        >
                            <i className="bi bi-eye"></i>
                        </Link>


                        <button
                            className="btn btn-warning"
                            onClick={() => { editAttribute(row.original.id, row.original.name) }}
                        >
                            <i className="bi bi-pencil"></i>
                        </button>
                        <button
                            className="btn btn-danger"
                            onClick={() => { confirmDelete(row.original.id, row.original.name) }}
                        >
                            <i className="bi bi-trash"></i>
                        </button>

                    </div>
                </>
            ),
        },
    ];
    const confirmDelete = async (id, title) => {
        await helper.sweetalert
            .confirm(`confirm to delete ${title}`, "warning")
            .then(async (result) => {
                if (result.isConfirmed) {
                    setShowLoader(true);
                    await attributesModel.destroy(id).then((res) => {
                        reloadAttributeData();
                        helper.sweetalert.toast(`${title} deleted Successfully`);
                    });
                    setShowLoader(false);
                }
            });
    };
    const editAttribute = async (id, title) => {
        setValue("id", id);
        setValue("name", title);
        setShow(true);
    };
    return (
        <>
            <Heading title="Attributes" showLoader={isLoading || showLoader}>
                {console.log()}
                <Button className="btn btn-primary btn-sm" onClick={handleShow}>
                    <i className="bi bi-plus" />  Create
                </Button>
            </Heading>
            <Modal show={show} onHide={handleClose}>
                <form onSubmit={onSubmit} method="post" encType='multipart/form-data'>
                    <Card>
                        {watch('id') ? (
                            <Card.Header className="card-header fs-3 ">Edit Attribute</Card.Header>
                        ) : (
                            <Card.Header className="card-header fs-3 ">Create Attribute</Card.Header>
                        )}

                        <Card.Body>
                            <div className="form-group">
                                <label className="form-label">Name</label>
                                <input
                                    type="text"
                                    placeholder="Enter attribute name"
                                    className={`form-control ${errors?.name && "is-invalid"}`}
                                    {...register("name", {
                                        required: "Name is required",
                                    })}
                                />
                                <div className="invalid-feedback">
                                    {errors.name && errors.name.message}
                                </div>
                            </div>
                        </Card.Body>
                        <Card.Footer>
                            <button type="submit" className="btn btn-primary float-end">
                                Save
                            </button>
                        </Card.Footer>
                    </Card>
                </form>
            </Modal>
            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">Attributes List</div>
                    <div className="table-responsive">
                        <Table columns={columns} data={attributeData?.data || []} />
                    </div>
                    <div className="card-footer">
                        <Pagination meta={attributeData?.meta} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
